<template>
  <div
    class="toggle"
    :class="[checked ? 'toggle-active active' : 'toggle-inactive']"
    @click="toggleAction()"
  >
    <div type="checkbox" class="toggle-rounded"></div>
  </div>
</template>

<script>
export default {
  name: "AppToggle",
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    toggleAction() {
      this.$emit("update:checked", !this.$props.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  cursor: pointer;
  display: flex;
  padding: 0.5em;
  justify-content: flex-start;
  align-items: center;
  height: 2em;
  width: 4em;
  border-radius: 2em;
  transition: all 0.5s ease;

  &-active {
    background-color: #34c759;
  }

  &-inactive {
    background-color: #e4e4e4;
  }

  &-rounded {
    width: 1.5em;
    height: 1.5em;
    border-radius: 5em;
    transform: translateX(0);
    transition: all 0.5s ease-in;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);
    background-color: white;
  }
}

.active {
  .toggle-rounded {
    transform: translateX(100%);
    transition: all 0.5s ease-out;
  }
}
</style>